import React, { type FC } from "react";
import type { ApiStockLot } from "@src/businessModules/Stock/api/lots";

/** Минимальный контракт партии для read-only отображения. */
export type BusinessLotValueLot = Pick<ApiStockLot, "LotNum">;

/** Пропсы компонента {@link BusinessLotValue}. */
export interface BusinessLotValueProps {
    /** Партия для read-only отображения. */
    lot?: BusinessLotValueLot | null;
    /** Текст или узел для пустого значения. @default "Не задано" */
    fallback?: React.ReactNode;
    /** Дополнительный CSS-класс корневого контейнера. */
    className?: string;
}

function resolveTextPart(value: string | null | undefined): string | null {
    const text = value?.trim();
    return text === "" ? null : (text ?? null);
}

/**
 * Формирует plain-text представление партии.
 * @param lot партия
 * @returns номер партии или пустая строка
 */
export function formatLotText(lot?: BusinessLotValueLot | null): string {
    if (lot == null) {
        return "";
    }

    return resolveTextPart(lot.LotNum) ?? "";
}

/** Read-only отображение партии. */
export const BusinessLotValue: FC<BusinessLotValueProps> = ({ lot, fallback = "Не задано", className }) => {
    const lotText = formatLotText(lot);

    if (lotText === "") {
        return <span className={className}>{fallback}</span>;
    }

    return <span className={className}>{lotText}</span>;
};
